export default "/build/images/hyundau.png?1f8268d68a145c2af7943c31f348784f";